// extracted by mini-css-extract-plugin
export default {"wrapper":"HGfBgj","text":"fXW62b","block":"z2bPzZ"};